module.exports = __webpack_public_path__ + "media/stylesheets/images/media/banner_folk-1cbdcf270c72c5426684bb78926a8955.png";